// Main.js
import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import Necklace from "../assets/neckles.png";
import Boy from "../assets/boy.png";
import CmsService from "../services/API/CmsService";

export const Hero = () => {
  const sectionOneRef = useRef(null);
  const sectionTwoRef = useRef(null);
  const necklaceRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (!isAnimating) {
        const sectionOneBottom = sectionOneRef.current.getBoundingClientRect().bottom;
        if (sectionOneBottom <= window.innerHeight && st > lastScrollTop) {
          // Scrolling down
          setIsAnimating(true);
          sectionOneRef.current.classList.add('hidden');
          sectionTwoRef.current.classList.add('visible');
          necklaceRef.current.classList.remove('backanimate');
          necklaceRef.current.classList.add('animate');

          setTimeout(() => {
            setIsAnimating(false);
          }, 2000); // Duration of the animation
        } else if (st < lastScrollTop) {
          // Scrolling up
          setIsAnimating(true);
          sectionOneRef.current.classList.remove('hidden');
          sectionTwoRef.current.classList.remove('visible');
          necklaceRef.current.classList.remove('animate');
          necklaceRef.current.classList.add('backanimate');

          setTimeout(() => {
            setIsAnimating(false);
          }, 2000); // Duration of the back animation
        }
      }
      setLastScrollTop(st <= 0 ? 0 : st); // For Mobile or negative scrolling
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isAnimating, lastScrollTop]);

  const [data, setData] = useState([]);
  const [heading, setHeading] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSecondBanner = async () => {
    try {
      const res = await CmsService.secoundSection();
      const response = res.data[0];
      setData(response);
      console.log('banner', response);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };

  const mainBanner = async () => {
    try {
      const res = await CmsService.mainSection();
      const response = res.data[0];
      setHeading(response);
      console.log('banner', response);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    mainBanner();
    fetchSecondBanner();
  }, []);

  return (
    <>
      <section id="sectionOne" ref={sectionOneRef}>
        <Container>
          <div className="text-left">
            <h2>{heading.first_heading}</h2>
          </div>
          <h1>{heading.secound_heading}</h1>
          <div className="text-right">
            <h2>{heading.third_heading}</h2>
          </div>
          <div className="necklace">
            <div className="circle"></div>
            <img src={Necklace} id="necklaceImg" ref={necklaceRef} style={{ position: 'absolute', left: '50%'}} />
          </div>
        </Container>
      </section>
      <section id="sectionTwo" ref={sectionTwoRef} style={{ position: "relative", overflow: 'hidden', paddingTop: '200px' }}>
        <div className="container">
          <div className="row main-row align-items-center md:flex-col-reverse sm:flex-col-reverse lg:flex-row">
            <div className="col-lg-6">
              <div className="pad-col">
                <h2>{data.title}</h2>
                <p>{data.description}</p>
                <div className="buttons">
                  <button>View</button>
                  <button>Collection</button>
                </div>
              </div>
            </div>
            <div className="col-lg-6 p-0 mainexercise" >
              <img
                style={{
                  objectFit: "contain",
                  height: "100%",
                  width: '507px',
                  transform: "translate(0px, -104px)",
                }}
                src={Boy}
                alt="Boy"
                id="boyImg"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
